import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'fade', 'iconUp', 'iconDown']
  static values  = {
    height:         { type: Number, default: 140 },
    expandedHeight: { type: Number, default: 480 }
  }

  connect() {
    this.contentTarget.style.transition = 'max-height 0.35s ease'
    this._applyCollapsed()
    this._expanded = false
    if (this.hasFadeTarget)    this.fadeTarget.classList.remove('hidden')
    if (this.hasIconUpTarget)  this.iconUpTarget.classList.add('hidden')
    if (this.hasIconDownTarget) this.iconDownTarget.classList.remove('hidden')
  }

  toggle() {
    this._expanded = !this._expanded
    if (this._expanded) this._applyExpanded()
    else this._applyCollapsed()

    if (this.hasFadeTarget) this.fadeTarget.classList.toggle('hidden', this._expanded)
    if (this.hasIconUpTarget)   this.iconUpTarget.classList.toggle('hidden', !this._expanded)
    if (this.hasIconDownTarget) this.iconDownTarget.classList.toggle('hidden', this._expanded)
  }

  _applyCollapsed() {
    this.contentTarget.style.overflow  = 'hidden'
    this.contentTarget.style.maxHeight = `${this.heightValue}px`
  }

  _applyExpanded() {
    this.contentTarget.style.overflowY = 'auto'
    this.contentTarget.style.overflowX = 'hidden'
    this.contentTarget.style.maxHeight = `${this.expandedHeightValue}px`
  }
}
